import { apiClient, WEBSITE_TASKS } from '../../../../shared/api';

export const fetchTasks = async () => {
  const response = await apiClient.get(WEBSITE_TASKS());

  return response.data;
};
